import {
    FiltersAction,
    FiltersActionTypes,
    SearchFilters
} from "../interfaces/context/searchContextInterfaces";

const defaultState = {
    category: [],
    industry: [],
    experienceLevel: [],
    perks: [],
    companySize: [],
    radius: "",
    postedDateRange: "",
    companyLeadership: []
};

export const filtersReducer = (state: SearchFilters, action: FiltersAction) => {
    switch (action.type) {
    case FiltersActionTypes.updateFilter: {
        const updatedState = {
            ...state,
            ...action.payload
        };
        return updatedState;
    }
    case FiltersActionTypes.resetAllFilters: {
        return defaultState;
    }
    default: {
        return state;
    }
    }
};
